module.exports = __webpack_public_path__ + "img/logo_azvi.af15056c.png";